import { registerCapability } from '../../platform/capability-registry';
import { MaasNodeGroupsBlock } from './MaasNodeGroupsBlock';
import { MAAS_NODE_GROUPS_FIELD_KEY_LIST } from './fieldKeys';
import { resolveMaasNodeGroupsPaths } from './resolvePaths';
import type { MaasNodeGroupsBlockOptions } from './types';

registerCapability<MaasNodeGroupsBlockOptions>({
  key: 'maas-node-groups',
  fields: [...MAAS_NODE_GROUPS_FIELD_KEY_LIST],
  component: MaasNodeGroupsBlock,
  defaultPaths: (prefix) => resolveMaasNodeGroupsPaths(prefix),
  resolvePaths: (prefix) => resolveMaasNodeGroupsPaths(prefix),
});
